import type { paths } from '@orlikfy/api-interfaces';

export type {
  ChannelGameDto,
  ChannelMemberDto,
  GetChannelDetailsDto,
  GetChannelMembersDto,
  SingleChannelDto
} from '@orlikfy/api-interfaces';

// GET /chat/user/me
export const GET_MY_CHAT_USER_PATH = '/chat/user/me' as const satisfies keyof paths;
type GetMyChatUserOperation = paths[typeof GET_MY_CHAT_USER_PATH]['get'];
export type GetMyChatUserResponse = GetMyChatUserOperation['responses'][200]['content']['application/json'];

// GET /chat/channel/{channelId}
export const GET_CHANNEL_DETAILS_PATH = '/chat/channel/{channelId}' as const satisfies keyof paths;
type GetChannelDetailsOperation = paths[typeof GET_CHANNEL_DETAILS_PATH]['get'];
export type GetChannelDetailsPathParams = GetChannelDetailsOperation['parameters']['path'];
export type GetChannelDetailsResponse = GetChannelDetailsOperation['responses'][200]['content']['application/json'];

// GET /chat/channel/get-by-reference
export const GET_CHANNEL_BY_REFERENCE_PATH = '/chat/channel/get-by-reference' as const satisfies keyof paths;
type GetChannelByReferenceOperation = paths[typeof GET_CHANNEL_BY_REFERENCE_PATH]['get'];
export type GetChannelByReferenceResponse =
  GetChannelByReferenceOperation['responses'][200]['content']['application/json'];

// POST /chat/channel/single
export const CREATE_SINGLE_CHAT_PATH = '/chat/channel/single' as const satisfies keyof paths;
type CreateSingleChatOperation = paths[typeof CREATE_SINGLE_CHAT_PATH]['post'];
export type CreateSingleChatBody = CreateSingleChatOperation['requestBody']['content']['application/json'];
export type CreateSingleChatResponse = CreateSingleChatOperation['responses']['default']['content']['application/json'];

// GET /chat/channel/single/{userId}
export const GET_SINGLE_CHANNEL_PATH = '/chat/channel/single/{userId}' as const satisfies keyof paths;
type GetSingleChannelOperation = paths[typeof GET_SINGLE_CHANNEL_PATH]['get'];
export type GetSingleChannelPathParams = GetSingleChannelOperation['parameters']['path'];
export type GetSingleChannelResponse = GetSingleChannelOperation['responses'][200]['content']['application/json'];

// PATCH /chat/channel/{channelId}/muted
export const MUTE_CHANNEL_PATH = '/chat/channel/{channelId}/muted' as const satisfies keyof paths;
type MuteChannelOperation = paths[typeof MUTE_CHANNEL_PATH]['patch'];
export type MuteChannelPathParams = MuteChannelOperation['parameters']['path'];
export type MuteChannelBody = MuteChannelOperation['requestBody']['content']['application/json'];
